import React, { useContext } from 'react';

import { Flexer } from '@ontruck/orc';

import DedicatedContractsAssignmentContext from '../context';

import { StyledNoWrap } from 'modules/assignment-cards/styled';

import MarginInfo from './MarginInfo';

const HeaderInfo = ({ id }) => {
  const { dedicatedContractsObject } = useContext(DedicatedContractsAssignmentContext);

  const contract = dedicatedContractsObject[id];

  if (!contract) {
    return null;
  }

  const { driver } = contract;

  return (
    <>
      <Flexer.Child mLeft="XS" flex="1" data-testid="driver_name">
        {driver.contact_name}
      </Flexer.Child>
      <Flexer.Child mLeft="XS" flex="0">
        <StyledNoWrap>
          <MarginInfo id={id} />
        </StyledNoWrap>
      </Flexer.Child>
    </>
  );
};

export default HeaderInfo;
